import React, { useContext } from 'react';

import { useViewport } from 'contexts/viewport';
import withResponsiveLayout from 'hoc/withResponsive';
import Mobile from 'pages/Survey/mobile';
import Tablet from 'pages/Survey/tablet';
import Desktop from 'pages/Survey/desktop';
import { PageContext } from 'pages/Survey/PageProvider';
import QuestionTemplate from 'components/organisms/Survey/QuestionTemplate';
import { FinishedSurvey, MobileQuestionTemplate } from 'components/organisms/Survey';

const SurveyPage = () => {
    const { width } = useViewport();
    const {
        loading,
        steps,
        stepKeys,
        currentStep,
        canSubmit,
        review,
        handleClickNext,
        handleClickBack,
        handleClickToReview,
        handleClickToCourseDashboard,
    } = useContext(PageContext);

    const responsiveModalSizes = {
        mobile: 'mobile',
        tablet: 'tablet',
        desktop: 'desktop',
    };
    const device = withResponsiveLayout(width, responsiveModalSizes);

    const renderPage = () => {
        switch (currentStep) {
            case stepKeys.SURVEY: {
                if (device === 'mobile') return <MobileQuestionTemplate />;
                return <QuestionTemplate />;
            }

            case stepKeys.FINISHED_SURVEY: {
                return (
                    <FinishedSurvey
                        handleClickToReview={() => handleClickToReview()}
                        handleClickToCourseDashboard={handleClickToCourseDashboard}
                    />
                );
            }
            default: {
                return <></>;
            }
        }
    };

    const passingProps = {
        platform: process.env.REACT_APP_AUTH,
        loading,
        currentStep,
        steps: steps || [],
        stepKeys,
        review,
        canSubmit,
        handleClickNext,
        handleClickBack,
        renderPage,
        disableNext: false,
    };

    const responsiveLayouts = {
        mobile: <Mobile {...passingProps} />,
        tablet: <Tablet {...passingProps} />,
        desktop: <Desktop {...passingProps} />,
    };

    return withResponsiveLayout(width, responsiveLayouts);
};

export default SurveyPage;
